import { useQuery } from "convex/react";
import { Coins } from "lucide-react";
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@repo/ui";
import { motPluriel } from "@repo/utils";
import { api } from "@convex/_generated/api";

/**
 * Solde de crédits de l'organisation.
 *
 * Le solde peut être NÉGATIF : les organisations consomment aujourd'hui sans
 * avoir acheté, et rien ne les bloque. Un solde à découvert n'est donc pas une
 * anomalie à alerter — c'est la mesure de ce qui a été consommé. L'écran le
 * nomme pour ce qu'il est plutôt que d'afficher « -12 crédits disponibles ».
 */
export function CarteCredits() {
  const org = useQuery(api.organisation.monOrganisation);

  const credits = org?.credits;
  const aDecouvert = credits !== undefined && credits < 0;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Crédits</CardTitle>
        <CardDescription>
          Solde de crédits de votre organisation.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-surface bg-charte-wash-accent">
            <Coins className="h-5 w-5 text-charte-accent" />
          </div>
          <div>
            <p className="text-2xl font-semibold">
              {credits === undefined ? "—" : credits}
            </p>
            <p className="text-sm text-muted-foreground">
              {credits === undefined
                ? "crédit disponible"
                : aDecouvert
                  ? `${motPluriel(credits, "crédit")} ${motPluriel(credits, "consommé")} au-delà du solde`
                  : `${motPluriel(credits, "crédit")} ${motPluriel(credits, "disponible")}`}
            </p>
          </div>
        </div>

        {/* Achat non ouvert pour l'instant : le bouton est rendu désactivé
            plutôt que masqué, pour annoncer la fonctionnalité à venir.
            `span` intercalaire : un bouton désactivé n'émet pas d'événement
            de survol, le tooltip ne s'afficherait jamais sans lui. */}
        <Tooltip>
          <TooltipTrigger asChild>
            <span tabIndex={0}>
              <Button disabled>Acheter des crédits</Button>
            </span>
          </TooltipTrigger>
          <TooltipContent>Bientôt disponible</TooltipContent>
        </Tooltip>
      </CardContent>
    </Card>
  );
}
